import React from 'react';
import { Empty } from 'antd';

export const SelectEmptyContent =  <div style={ { textAlign: 'center', lineHeight: '32px' } }>No Data</div>
export const TableEmptyContent = <Empty image={ Empty.PRESENTED_IMAGE_SIMPLE } description="No data"/>